import { Helmet } from "react-helmet";
import { RegDiv } from "../../Components";
import Navbar from "../../Navigation";
import "./index.css";
import React, { useState, useEffect } from "react";

export default function PrivacyPolicy () {
  return (
    <div className="privacy-page"
      style={{
        maxWidth: "900px",
        margin: "0 auto",
        padding: "40px 20px",
        lineHeight: "1.7",
        color: "#333",
      }}
    >
      <h1>Privacy Policy for Tennis Master Mobile App</h1>
      <p>
        <strong>Last Updated:</strong> November 16, 2025
      </p>

      <p>
        Tennis Master ("we", "our", or "us") provides a mobile and web
        application that helps users improve their tennis skills using video
        analysis, pose detection, artificial intelligence, and personalized
        coaching insights. We are committed to protecting your privacy and
        handling your data responsibly.
      </p>

      <p>
        This Privacy Policy explains what information we collect, how we use it,
        and your rights regarding your personal data.
      </p>

      <h2>1. Information We Collect</h2>

      <h3>1.1 Information You Provide</h3>
      <ul>
        <li>
          <strong>Account Information:</strong> Name, email address, phone
          number, password.
        </li>
        <li>
          <strong>Profile Information:</strong> Handedness (left/right),
          preferred language, training preferences.
        </li>
        <li>
          <strong>Videos & Images:</strong> Videos that you upload for tennis
          swing analysis.
        </li>
        <li>
          <strong>Feedback & Support Messages:</strong> Emails or messages sent
          to customer support.
        </li>
      </ul>

      <h2>2. Information We Automatically Collect</h2>
      <ul>
        <li>We follow minimum information collection principles.</li>
        <li>
          <strong>Device Information:</strong> Device model, operating system,
          browser type.
        </li>
        <li>
          <strong>Usage Data:</strong> Pages viewed, features used, session
          duration, and error logs.
        </li>
        <li>
          <strong>Analytics Data:</strong> Aggregated statistics used to improve
          the application.
        </li>
      </ul>

      <h2>3. AI & Video Processing</h2>

      <p>
        Tennis Master uses local and cloud-based machine learning to analyze:
      </p>

      <ul>
        <li>Body pose and joint positions</li>
        <li>Swing mechanics</li>
        <li>Movement patterns</li>
        <li>Performance metrics</li>
      </ul>

      <h3>Important</h3>
      <ul>
        <li>
          Videos may be processed in the cloud. All videos are encrypted during
          transmission and deleted immediately after processing.
        </li>
        <li>We do not use your videos to train public AI models.</li>
      </ul>

      <h2>4. How We Use Your Information</h2>

      <p>We use your data to:</p>

      <ul>
        <li>Provide swing analysis and coaching feedback</li>
        <li>Improve app performance and user experience</li>
        <li>Communicate updates or important messages</li>
        <li>Provide customer support</li>
        <li>Detect abuse or misuse</li>
      </ul>

      <p>
        <strong>We never sell your data.</strong>
      </p>

      <h2>5. Sharing of Information</h2>

      <p>We may share information only with:</p>

      <ul>
        <li>Service providers (hosting, analytics, and error reporting)</li>
        <li>Cloud processing providers for optional video analysis</li>
        <li>Legal authorities when required by law</li>
      </ul>

      <p>We do not share your personal data with advertisers.</p>

      <h2>6. Data Storage & Security</h2>

      <p>We implement industry-standard security practices including:</p>

      <ul>
        <li>Encrypted data transmission (HTTPS)</li>
        <li>Secure storage with restricted access</li>
        <li>
          Automatic deletion of uploaded videos after processing (where
          cloud-based processing is used)
        </li>
      </ul>

      <h2>7. Your Rights</h2>

      <p>
        Depending on your region, you may have the right to:
      </p>

      <ul>
        <li>Access the personal data we hold about you</li>
        <li>Request deletion of your account and data</li>
        <li>Update or correct your information</li>
        <li>Withdraw consent where applicable</li>
      </ul>

      <p>
        To request deletion, email us at:
        <br />
        <strong>tennismasterapp@gmail.com</strong>
      </p>

      <h2>8. Children's Privacy</h2>

      <p>
        Tennis Master is not intended for users under the age of 4.
        We do not knowingly collect personal data from children.
      </p>

      <h2>9. International Data Transfers</h2>

      <p>
        Your data may be processed on servers located in other countries.
        We follow legal safeguards for international transfers, including
        Standard Contractual Clauses where required.
      </p>

      <h2>10. Changes to This Policy</h2>

      <p>
        We may update this Privacy Policy periodically.
        Users will be notified of significant changes through in-app
        notifications or email.
      </p>

      <h2>11. Contact Us</h2>

      <p>
        If you have questions about this Privacy Policy or would like to make a
        data request, contact us:
      </p>

      <p>
        <strong>Email:</strong> tennismasterapp@gmail.com
        <br />
        <strong>Company:</strong> TennisMaster Club
        <br />
        <strong>Address:</strong> Vancouver, BC, Canada
      </p>
    </div>
  );
}

